<template>
  <div :class="props.class">
    <div class="base_date_picker tw-group tw-border" :class="[
        errorMessage ? 'tw-border-red-200' : ' tw-border-blue-dark-50',
       ]">
      <div :class="[
      'tw-w-[calc(100%_-_35px)] tw-h-full tw-p-2',
       errorMessage && '!tw-text-red-500',
      'id_' + select_id
    ]" >
        <div class="input_placeholder" :class="[date && 'is_title']" v-text="title"></div>
        <base-animated-text v-if="date" :text="Array.isArray(date) ? (date.length > 1 ? date[0] + ' تا ' + date[1] : date[0]) : date"></base-animated-text>
      </div>

      <div class="tw-overflow-hidden tw-flex tw-justify-end tw-items-center tw-relative tw-w-14 tw-h-6 max-md:tw-w-14">
        <base-icon v-if="date"
                   @click="deleteValue"
                   icon="close"
                   class="tw-text-blue-dark-200 tw-p-1 md:tw-absolute tw-top-[-150%] tw-transition-all tw-duration-200 group-hover:tw-top-[-1px] hover:tw-text-red-200" size="20" />
        <base-icon icon="event"
                   :class="[
                   'id_' + select_id,
                    date && 'md:tw-absolute tw-top-0 group-hover:tw-top-[150px]'
                 ]"
                   class="tw-transition-all tw-duration-200" />
      </div>
    </div>
    <date-picker v-model="date"
                 type="date"
                 :custom-input="'.id_' + select_id"
                 @change="() => updateValue(date)"
                 auto-submit
                 :range="range"/>
    <p class="tw-text-red-500 tw-text-tiny tw-mb-0" v-text="errorMessage"></p>
  </div>
</template>

<script setup>

import { ref, watch, defineEmits } from 'vue';
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import BaseIcon from "@/components/base/BaseIcon.vue";
import BaseAnimatedText from "@/components/base/BaseAnimatedText.vue";
const datePicker = Vue3PersianDatetimePicker;


const internalUpdate = ref(false)
const date = ref(null);
const select_id = Date.now().toString(36);
const emit = defineEmits(['update:modelValue', 'change']);
const props = defineProps({
  modelValue: {
    type: String,
    default: null
  },
  title: {
    type: String,
    value: '',
  },
  range: {
    type: Boolean,
    default: false
  },
  class: {
    type: String,
    default: ''
  },
  errorMessage: {
    type: String,
    default: null
  },
});

function deleteValue() {
  updateValue(null)
}

function updateValue (value) {
  if(date.value !== value) {
    date.value = value;
  }
  internalUpdate.value = true;
  emit('update:modelValue', value);
  emit('change', value)
}

watch(
  () => props.modelValue,
  (newVal) => {
    if(internalUpdate.value) {
      internalUpdate.value = false;
    } else {
      date.value = newVal;
    }
  });
</script>

<style scoped>

.base_date_picker {
  @apply tw-relative tw-flex tw-w-full tw-h-[40px] tw-pl-2 tw-justify-between tw-items-center tw-bg-white tw-rounded-lg tw-text-blue-dark-500 tw-cursor-pointer;
}

.input_placeholder{
  @apply tw-absolute tw-top-[8px] tw-right-2 tw-bg-white tw-px-1 tw-text-blue-dark-500 tw-transform;
}

.input_placeholder.is_title{
  @apply tw-top-[-11px] tw-right-1 tw-text-[11px] tw-text-blue-dark-400;
}
</style>
